import { bunja } from 'bunja';
import { addDays } from 'date-fns';

import { authBunja } from '@flipster/features/src/shared/auth/state';
import { PathnameScope, RouterScope } from '@flipster/react/providers/route';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { CookieKeys, getCookieBunja } from '@flipster/utils/cookie';
import { removeLocalePathname } from '@flipster/utils/pathname';

import { RequiredLoggedInPath, SignInPath } from '../../proxy';

const ExcludeReferrerPath = [...SignInPath, '/maintenance', '/auth', '/404'];
const RequiredKolPath = '/support/affiliate';
const BlockKolPath = '/support/referral';

export const authRedirectBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const pathname = bunja.use(PathnameScope);
  const router = bunja.use(RouterScope);
  const { isCookieLoggedInAtom, isKolAtom, waitLoading } = bunja.use(authBunja);
  const referralPath = bunja.use(getCookieBunja(CookieKeys.ReferralPath));

  const withoutLocalePathname = removeLocalePathname(pathname);

  function setReferrerPath(): void {
    if (ExcludeReferrerPath.some((p) => withoutLocalePathname.startsWith(p))) return;
    // pathname에는 query string, hash가 포함되어 있지 않으므로 window.location.href를 사용
    referralPath.update(window.location.href.replace(window.location.origin, ''), addDays(new Date(), 30));
  }

  function gotoLoginPage(): void {
    const isCookieLoggedIn = store.get(isCookieLoggedInAtom);
    if (isCookieLoggedIn) return;
    if (
      RequiredLoggedInPath.some((path) => {
        const regex = new RegExp(`^${path}($|/)`);
        return regex.test(withoutLocalePathname);
      })
    ) {
      router.replace('/login');
    }
  }

  function gotoAfterLoginPage(): void {
    const isCookieLoggedIn = store.get(isCookieLoggedInAtom);
    if (!isCookieLoggedIn) return;
    if (SignInPath.some((path) => withoutLocalePathname.startsWith(path))) {
      const target = removeLocalePathname(store.get(referralPath.cookieAtom) || '/');
      const shouldGotoAssets = target === '/';
      router.replace(shouldGotoAssets ? '/assets' : target);
    }
  }

  async function gotoReferralPage(): Promise<void> {
    await waitLoading();
    const isKol = store.get(isKolAtom);
    if (isKol) return;
    if (withoutLocalePathname.startsWith(RequiredKolPath)) {
      router.replace('/support/referral');
    }
  }

  async function gotoAffiliatePage(): Promise<void> {
    await waitLoading();
    const isKol = store.get(isKolAtom);
    if (!isKol) return;
    if (withoutLocalePathname.startsWith(BlockKolPath)) {
      router.replace('/support/affiliate');
    }
  }

  return {
    setReferrerPath,
    gotoLoginPage,
    gotoAfterLoginPage,
    gotoReferralPage,
    gotoAffiliatePage,
  };
});
authRedirectBunja.debugLabel = 'authRedirectBunja';
